import { inject } from '@angular/core'
import { Router, type CanMatchFn } from '@angular/router'
import { isPlacesAdminEnabled } from './runtime-config'

export const placesAdminFeatureGuard: CanMatchFn = () =>
  isPlacesAdminEnabled() ? true : inject(Router).createUrlTree(['/dashboard'])
